"use client";

import { Fragment, useState, useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Paper,
  Autocomplete,
  Tabs,
  Tab,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  Skeleton,
  Avatar,
  Stack,
  Divider,
  Collapse,
} from "@mui/material";
import {
  Phone,
  Person,
  Category,
  LocationCity,
  LocationOn,
  CallEnd,
  Comment,
  Send,
  Edit,
  Add,
  Remove,
  People,
  Assessment,
  FilterList,
  Refresh,
  ChevronLeft,
  ChevronRight,
  PhoneInTalk,
  SearchOff,
  OpenInNew,
  PictureAsPdf,
  Image as ImageIcon,
  CalendarToday,
  AccessTime,
  Timer,
  WhatsApp,
  LinkOff,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { preopenFollowUpWa } from "../../../utils/whatsappFollowUp";
import { getDecryptDataFromLocal } from "../../../utils/encrypt";

const AddLeadsForAgent = () => {
  const [activeTab, setActiveTab] = useState(0);
  
  // Get user role and phone number for access control
  const userRole = getDecryptDataFromLocal("setRole")
  const phoneNumber = getDecryptDataFromLocal("phoneNumber");
  const canUseWhatsappFeatures = localStorage.getItem("cohortTeam") === "true" || localStorage.getItem("cohorTeam") === "true";
  
  // Define access control for agent management
  const addLeadForAgentAccess = ["1", "17", "2", "8810613343"];
  const hasAgentManagementAccess = addLeadForAgentAccess.includes(userRole) || addLeadForAgentAccess.includes(phoneNumber);
  console.log(hasAgentManagementAccess,phoneNumber,userRole);
  const [unregisteredLeads, setUnregisteredLeads] = useState([]);
  const [formData, setFormData] = useState({
    phoneNumber: "",
    sellerName: "",
    productCategory: "",
    alternateNumber: "",
    city: "",
    state: "",
    callStatus: "",
    callRemark: "",
    followUpDateTime: "",
  });
  const [leadsDashboardData, setLeadDashboardData] = useState();
  const [loading, setLoading] = useState(true);
  const [dropdownOptions, setDropdownOptions] = useState({
    productCategories: [],
    cities: [],
    states: [],
    callStatuses: [],
  });
  
  // Agent management states
  const [agentsList, setAgentsList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [availableStates, setAvailableStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  
  // Table pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Search states
  const [searchQuery, setSearchQuery] = useState('');

  // Call Reports states
  const [callReports, setCallReports] = useState([]);
  const [callReportsLoading, setCallReportsLoading] = useState(false);
  const [callReportsMeta, setCallReportsMeta] = useState(null);
  const [callReportPage, setCallReportPage] = useState(1);
  const [callReportStatusFilter, setCallReportStatusFilter] = useState('');
  const [callReportAgentFilter, setCallReportAgentFilter] = useState('');
  const [callReportPhoneFilter, setCallReportPhoneFilter] = useState('');
  const [callReportAgents, setCallReportAgents] = useState([]);
  const [expandedCallRows, setExpandedCallRows] = useState({});
  const [callHistoryByPhone, setCallHistoryByPhone] = useState({});
  const [callHistoryLoadingByPhone, setCallHistoryLoadingByPhone] = useState({});

  // Catalog states
  const [catalogs, setCatalogs] = useState([]);
  const [selectedCatalogId, setSelectedCatalogId] = useState('');
  const [lastCatalogSent, setLastCatalogSent] = useState(null); // { catalogName, sentAt }
  const [catalogSending, setCatalogSending] = useState(false);
  const catalogPhoneRef = useRef(''); // track which phone we last fetched history for

  // WhatsApp states
  const [whatsappDialogOpen, setWhatsappDialogOpen] = useState(false);
  const [whatsappAgent, setWhatsappAgent] = useState(null); // agent object for current dialog
  const [whatsappQR, setWhatsappQR] = useState(null);       // base64 data URL
  const [whatsappStatus, setWhatsappStatus] = useState('not_initialized');
  const [whatsappConnecting, setWhatsappConnecting] = useState(false);
  const [agentWaStatuses, setAgentWaStatuses] = useState({}); // { agentId: status } for the agents table
  const whatsappPollRef = useRef(null);
  // For the self-connect flow (agent connecting their own WhatsApp)
  const [selfAgentId, setSelfAgentId] = useState(null);
  // Dedicated status for the currently logged-in agent — used by catalog dropdown & send logic
  const [myWaStatus, setMyWaStatus] = useState('not_initialized');

  // ── Catalog helpers ──────────────────────────────────────────────────────────

  const fetchCatalogs = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_PATH + '/whatsapp/catalogs');
      if (!res.data.error) setCatalogs(res.data.data);
    } catch (_) {}
  };

  const fetchLastCatalogForPhone = async (phone) => {
    const clean = String(phone).replace(/\D/g, '');
    if (clean.length !== 10 || clean === catalogPhoneRef.current) return;
    catalogPhoneRef.current = clean;
    try {
      const res = await axios.get(process.env.REACT_APP_PATH + `/whatsapp/catalog-history/${clean}`);
      if (!res.data.error && res.data.data?.last) {
        setLastCatalogSent(res.data.data.last);
      } else {
        setLastCatalogSent(null);
      }
    } catch (_) {
      setLastCatalogSent(null);
    }
  };

  const handleSendCatalog = async () => {
    if (!selectedCatalogId) { alert('Please select a catalog first'); return; }
    if (!formData.phoneNumber || formData.phoneNumber.length !== 10) { alert('Please enter a valid 10-digit phone number'); return; }
    if (myWaStatus !== 'ready') {
      alert('Your WhatsApp is not connected. Please click "Connect WhatsApp" and scan the QR code first.');
      return;
    }
    setCatalogSending(true);
    try {
      const res = await axios.post(process.env.REACT_APP_PATH + '/whatsapp/send-catalog', {
        catalogId: selectedCatalogId,
        customerPhone: formData.phoneNumber,
      });
      if (!res.data.error) {
        alert(res.data.message || 'Catalog sent successfully!');
        // Refresh last sent info
        catalogPhoneRef.current = ''; // force re-fetch
        await fetchLastCatalogForPhone(formData.phoneNumber);
      } else {
        alert(res.data.message || 'Failed to send catalog');
      }
    } catch (err) {
      alert(err?.response?.data?.message || 'Failed to send catalog');
    } finally {
      setCatalogSending(false);
    }
  };

  // ── End Catalog helpers ──────────────────────────────────────────────────────

  // ── WhatsApp helpers ────────────────────────────────────────────────────────

  const startWhatsappPoll = (agentId, isSelf = false) => {
    if (whatsappPollRef.current) clearInterval(whatsappPollRef.current);
    const url = isSelf
      ? process.env.REACT_APP_PATH + '/whatsapp/my-qr'
      : process.env.REACT_APP_PATH + `/whatsapp/qr/${agentId}`;

    let disconnectTicks = 0; // how many consecutive polls returned 'disconnected'

    whatsappPollRef.current = setInterval(async () => {
      try {
        const res = await axios.get(url);
        if (!res.data.error) {
          const { status, qrBase64, agentId: returnedId } = res.data.data;
          if (isSelf && returnedId) setSelfAgentId(returnedId);
          if (isSelf) setMyWaStatus(status);
          setWhatsappStatus(status);
          setWhatsappQR(qrBase64 || null);
          const key = returnedId || agentId;
          setAgentWaStatuses(prev => ({ ...prev, [key]: status }));

          if (status === 'ready' || status === 'auth_failure') {
            // Terminal states — stop polling
            clearInterval(whatsappPollRef.current);
            whatsappPollRef.current = null;
          } else if (status === 'disconnected') {
            // Baileys auto-reconnects after 5s — keep polling so we catch 'ready'
            // but give up after ~2 minutes of continuous disconnected state
            disconnectTicks++;
            if (disconnectTicks >= 40) {
              clearInterval(whatsappPollRef.current);
              whatsappPollRef.current = null;
            }
          } else {
            disconnectTicks = 0; // reset counter on any non-disconnected status
          }
        }
      } catch (_) {}
    }, 3000);
  };

  // Agent connecting their OWN WhatsApp (visible to all users)
  const handleConnectMyWhatsapp = async () => {
    setWhatsappAgent({ name: localStorage.getItem('name') || 'Me' });
    setWhatsappQR(null);
    setWhatsappConnecting(true);
    setWhatsappDialogOpen(true);

    try {
      // Check current status first via my-qr (no agentId needed)
      const statusRes = await axios.get(process.env.REACT_APP_PATH + '/whatsapp/my-qr');
      if (!statusRes.data.error) {
        const { status, agentId: id } = statusRes.data.data;
        if (id) setSelfAgentId(id);
        setMyWaStatus(status);
        setWhatsappStatus(status);
        if (status === 'ready') { setWhatsappConnecting(false); return; }
      }
    } catch (_) {}

    // Initialise session for self (no agentId in body → backend uses JWT userId)
    try {
      const connectRes = await axios.post(process.env.REACT_APP_PATH + '/whatsapp/connect', {});
      if (!connectRes.data.error && connectRes.data.agentId) {
        setSelfAgentId(connectRes.data.agentId);
      }
    } catch (_) {}

    setWhatsappConnecting(false);
    startWhatsappPoll(null, true); // isSelf=true → uses /my-qr endpoint
  };

  const handleOpenWhatsappDialog = async (agent) => {
    setWhatsappAgent(agent);
    setWhatsappQR(null);
    setWhatsappConnecting(true);
    setWhatsappDialogOpen(true);

    // Check current status first
    try {
      const statusRes = await axios.get(
        process.env.REACT_APP_PATH + `/whatsapp/status/${agent._id}`
      );
      if (!statusRes.data.error) {
        const { status } = statusRes.data.data;
        setWhatsappStatus(status);
        setAgentWaStatuses(prev => ({ ...prev, [agent._id]: status }));
        if (status === 'ready') {
          setWhatsappConnecting(false);
          return; // already connected, no need to re-init
        }
      }
    } catch (_) {}

    // Initialise session
    try {
      await axios.post(process.env.REACT_APP_PATH + '/whatsapp/connect', {
        agentId: agent._id,
      });
    } catch (_) {}

    setWhatsappConnecting(false);
    startWhatsappPoll(agent._id);
  };

  const handleCloseWhatsappDialog = () => {
    if (whatsappPollRef.current) {
      clearInterval(whatsappPollRef.current);
      whatsappPollRef.current = null;
    }
    setWhatsappDialogOpen(false);
    setWhatsappQR(null);
    setWhatsappAgent(null);
  };

  const handleDisconnectWhatsapp = async (agentId) => {
    const id = agentId || selfAgentId;
    try {
      if (id) await axios.post(process.env.REACT_APP_PATH + '/whatsapp/disconnect', { agentId: id });
      setWhatsappStatus('not_initialized');
      setMyWaStatus('not_initialized');
      if (id) setAgentWaStatuses(prev => ({ ...prev, [id]: 'not_initialized' }));
      setWhatsappQR(null);
    } catch (_) {
      alert('Failed to disconnect WhatsApp');
    }
  };

  // Fetch WA statuses for all agents whenever list changes
  const fetchAllAgentWaStatuses = async (agents) => {
    const results = {};
    await Promise.allSettled(
      agents.map(async (a) => {
        try {
          const res = await axios.get(
            process.env.REACT_APP_PATH + `/whatsapp/status/${a._id}`
          );
          if (!res.data.error) results[a._id] = res.data.data.status;
        } catch (_) {}
      })
    );
    setAgentWaStatuses(results);
  };

  // ── End WhatsApp helpers ─────────────────────────────────────────────────────

  const submitData = (isDelete = false) => {
    setLoading(true);
    let payload = { ...formData };
    delete payload.followUpDateTime;
    if (formData.followUpDateTime && formData.callStatus.toLowerCase().includes("follow")) {
      payload.followUpTime = new Date(formData.followUpDateTime).toISOString();
    }
    if (unregisteredLeads.length > 0) {
      payload.UnregisteredLeadLogsId = unregisteredLeads[0]._id;
    }
    if (isDelete) {
      payload = {
        phoneNumber: formData.phoneNumber,
        personalCall: true,
        UnregisteredLeadLogsId: unregisteredLeads[0]._id
      };
    }
    // Follow-up (this form's HOT/WARM) → open WhatsApp to the buyer with the
    // agent's intro pre-typed. Opened inside the click so it isn't blocked.
    const wa = preopenFollowUpWa(formData.phoneNumber,
      !isDelete && String(formData.callStatus || '').toLowerCase().includes("follow"));

    axios
      .post(process.env.REACT_APP_PATH + "/sales/saveCallReportV1                                                                     ", payload)
      .then((res) => {
        if (res.data.success) {
          wa.go();
          alert(res.data?.message || "Successfully update");
          getAllCallReport();
          setFormData({
            phoneNumber: "",
            sellerName: "",
            productCategory: "",
            alternateNumber: "",
            city: "",
            state: "",
            callStatus: "",
            callRemark: "",
            followUpDateTime: "",
          });
          if (unregisteredLeads.length > 0) {
            getUnregisteredLeads();
          }
        } else {
          wa.cancel();
          alert(res.data?.message || "Something went wrong");
          setLoading(false);
        }
      })
      .catch((error) => {
        wa.cancel();
        alert("someting went wrong");
        setLoading(false);
      });
  };

  const getUnregisteredLeads = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_PATH + "/leads/getUnregisteredLeadsByAgent");
      if (response.data.success && response.data.data && response.data.data.data) {
        setUnregisteredLeads(response.data.data.data);
        if (response.data.data.data.length > 0) {
          const firstLead = response.data.data.data[0];
          const leadInfo = firstLead.leadInfo && firstLead.leadInfo.length > 0 ? firstLead.leadInfo[0] : null;
          const autoPhone = String(firstLead.phoneNumber);
          setFormData((prev) => ({
            ...prev,
            phoneNumber: autoPhone,
            ...(leadInfo && {
              sellerName: leadInfo.name || prev.sellerName,
              city: leadInfo.city || prev.city,
              state: leadInfo.state || prev.state,
            }),
          }));
          // Fetch catalog history for the auto-filled phone
          catalogPhoneRef.current = '';
          fetchLastCatalogForPhone(autoPhone);
        }
      }
    } catch (error) {
      console.log("Error fetching unregistered leads:", error);
    }
  };

  const getAllCallReport = async () => {
    setLoading(true);
    axios
      .get(process.env.REACT_APP_PATH + "/sales/getAgentCallReportDashboard")
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          setLeadDashboardData(res.data.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  // Agent management functions
  const getAgentsList = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_PATH + "/sales/getAgentList");
      if (response.data.success) {
        const agents = response.data.data;
        setAgentsList(agents);
        fetchAllAgentWaStatuses(agents);
      }
    } catch (error) {
      console.log("Error fetching agents:", error);
    }
  };

  const getBulkAgentsList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PATH_BULK}/admin/getBulkAgents`);
      if (response.data.success) {
        setCallReportAgents(response.data.data || []);
      }
    } catch (error) {
      console.log("Error fetching bulk agents:", error);
    }
  };

  const getCallReports = async (pageNum = 1, statusFilter = '', agentFilter = '', phoneFilter = '') => {
    setCallReportsLoading(true);
    try {
      const payload = { page: pageNum, limit: 20 };
      if (statusFilter) payload.callStatus = statusFilter;
      if (agentFilter) payload.agentId = agentFilter;
      if (phoneFilter) payload.phoneNumber = phoneFilter;
      const response = await axios.post(
        process.env.REACT_APP_PATH + "/sales/getAgentCallReports",
        payload
      );
      if (!response.data.error) {
        setCallReports(response.data.data.reports || []);
        setCallReportsMeta(response.data.data.metaData);
        setExpandedCallRows({});
      }
    } catch (error) {
      console.log("Error fetching call reports:", error);
    } finally {
      setCallReportsLoading(false);
    }
  };

  const getCatalogHistoryForPhone = async (phone) => {
    const clean = String(phone || '').replace(/\D/g, '');
    if (!clean) return;
    if (callHistoryByPhone[clean]) return;

    setCallHistoryLoadingByPhone((prev) => ({ ...prev, [clean]: true }));
    try {
      const response = await axios.get(process.env.REACT_APP_PATH + `/whatsapp/catalog-history/${clean}`);
      const history = response?.data?.data?.reports || response?.data?.data?.history || response?.data?.data || [];
      setCallHistoryByPhone((prev) => ({
        ...prev,
        [clean]: Array.isArray(history) ? history : [],
      }));
    } catch (error) {
      console.log("Error fetching catalog history:", error);
      setCallHistoryByPhone((prev) => ({ ...prev, [clean]: [] }));
    } finally {
      setCallHistoryLoadingByPhone((prev) => ({ ...prev, [clean]: false }));
    }
  };

  const toggleCallReportRow = async (phone) => {
    const clean = String(phone || '').replace(/\D/g, '');
    if (!clean) return;

    const nextExpanded = !expandedCallRows[clean];
    setExpandedCallRows((prev) => ({ ...prev, [clean]: nextExpanded }));

    if (nextExpanded && !callHistoryByPhone[clean]) {
      await getCatalogHistoryForPhone(clean);
    }
  };

  const updateAgentStates = async (agentId, newStates) => {
    try {
      const response = await axios.post(process.env.REACT_APP_PATH + "/sales/updateStateInAgent", {
        agentId: agentId,
        assignedState: newStates
      });
      if (response.data.success) {
        alert("Agent states updated successfully");
        getAgentsList(); // Refresh the list
        setEditDialogOpen(false);
      } else {
        alert("Failed to update agent states");
      }
    } catch (error) {
      console.log("Error updating agent states:", error);
      alert("Error updating agent states");
    }
  };

  const handleEditAgent = (agent) => {
    setSelectedAgent(agent);
    setSelectedStates(agent.assignedState ? [...agent.assignedState] : []);
    setEditDialogOpen(true);
  };

  const handleStateToggle = (state) => {
    setSelectedStates(prev => {
      if (prev.includes(state)) {
        // Remove state if already selected
        return prev.filter(s => s !== state);
      } else {
        // Add state if not selected
        return [...prev, state];
      }
    });
  };

  const handleSaveAgentStates = () => {
    if (selectedAgent) {
      // Ensure we have a clean array without duplicates
      const cleanStates = [...new Set(selectedStates)];
      updateAgentStates(selectedAgent._id, cleanStates);
    }
  };

  // Select all states
  const handleSelectAllStates = () => {
    setSelectedStates([...availableStates]);
  };

  // Deselect all states
  const handleDeselectAllStates = () => {
    setSelectedStates([]);
  };

  // Toggle all states (if all selected, deselect all; otherwise select all)
  const handleToggleAllStates = () => {
    if (selectedStates.length === availableStates.length) {
      handleDeselectAllStates();
    } else {
      handleSelectAllStates();
    }
  };

  // Table pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Filter agents based on search criteria
  const filteredAgents = agentsList.filter(agent => {
    const query = searchQuery.toLowerCase();
    const nameMatch = agent.name.toLowerCase().includes(query);
    const phoneMatch = agent.userName.includes(searchQuery);
    return nameMatch || phoneMatch;
  });

  // Reset page when search changes
  useEffect(() => {
    setPage(0);
  }, [searchQuery]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        let getCityAndState = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=cityAndState"
        );
        let productCategories = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=productCategories"
        );
        let callStatus = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=callStatus"
        );
        let states = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=states"
        );
        
        if (getCityAndState.data && productCategories.data && callStatus.data && states.data) {
          setDropdownOptions({
            productCategories: productCategories.data.data,
            cities: getCityAndState.data.data,
            callStatuses: callStatus.data.data,
          });
          
          // Use dedicated states API and remove duplicates
          const uniqueStates = [...new Set(states.data.data)].sort();
          setAvailableStates(uniqueStates);
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchDropdownData();
    getAllCallReport();
    getAgentsList();
    getBulkAgentsList();
    getUnregisteredLeads();
    fetchCatalogs();

    // Check the logged-in agent's own WhatsApp status on mount
    axios.get(process.env.REACT_APP_PATH + '/whatsapp/my-qr')
      .then(res => {
        if (!res.data.error && res.data.data) {
          const { agentId: id, status } = res.data.data;
          setMyWaStatus(status);
          if (id) {
            setSelfAgentId(id);
            setAgentWaStatuses(prev => ({ ...prev, [id]: status }));
          }
        }
      }).catch(() => {});
  }, []);

  // Handle form input changes
  const handleInputChange = (field, value) => {
    if (field == "alternateNumber" || field == "phoneNumber") {
      if (value.length <= 10) {
        setFormData((prev) => ({
          ...prev,
          [field]: value,
        }));
      }
      // Fetch last catalog sent to this number once it's 10 digits
      if (field === "phoneNumber" && value.length === 10) {
        fetchLastCatalogForPhone(value);
      } else if (field === "phoneNumber" && value.length < 10) {
        setLastCatalogSent(null);
        catalogPhoneRef.current = '';
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }

    // Auto-select state based on city selection
    if (field === "city") {
      const selectedCity = dropdownOptions.cities.find(
        (city) => city.city === value
      );
      if (selectedCity) {
        setFormData((prev) => ({
          ...prev,
          state: selectedCity.state,
        }));
      }
    }
  };

  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return null;
    const s = Math.floor(Number(seconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    if (h > 0) return `${h}h ${m} min ${sec} sec`;
    if (m > 0) return `${m} min ${sec} sec`;
    return `${sec} sec`;
  };

  const getStatusStyle = (status = '') => {
    const s = status.toLowerCase();
    if (s.includes('not interested'))   return { bg: '#fce4ec', color: '#c62828', border: '#ef9a9a' };
    if (s.includes('interested'))       return { bg: '#e8f5e9', color: '#2e7d32', border: '#a5d6a7' };
    if (s.includes('follow'))           return { bg: '#fff3e0', color: '#e65100', border: '#ffcc80' };
    if (s.includes('not reachable') || s.includes('no answer') || s.includes('switch')) return { bg: '#f3f4f6', color: '#374151', border: '#d1d5db' };
    if (s.includes('register') || s.includes('convert')) return { bg: '#e3f2fd', color: '#1565c0', border: '#90caf9' };
    return { bg: '#ede9fe', color: '#5b21b6', border: '#c4b5fd' };
  };

  const getCatalogAssetUrl = (item = {}) => {
    return item.previewUrl || item.fileUrl || item.mediaUrl || item.documentUrl || item.imageUrl || item.image || item.pdfUrl || item.link || item.url || '';
  };

  const getCatalogAssetType = (url = '') => {
    const cleanUrl = String(url).toLowerCase().split('?')[0];
    if (/\.(png|jpe?g|webp|gif|bmp|svg)$/.test(cleanUrl)) return 'image';
    if (cleanUrl.endsWith('.pdf')) return 'pdf';
    return '';
  };

  const shouldAutoLoadCallReports = activeTab === 1;

  useEffect(() => {
    if (!shouldAutoLoadCallReports) return;
    getCallReports(callReportPage, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter);
  }, [activeTab]);

  useEffect(() => {
    if (!shouldAutoLoadCallReports) return;
    if (callReportPhoneFilter.length === 10) {
      setCallReportPage(1);
      getCallReports(1, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter);
    }
  }, [callReportPhoneFilter, activeTab, callReportAgentFilter]);

  return (
    <div style={{position:'relative'}}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{ backgroundColor: "#fff" }}
      >
        <Typography variant="h4">Agent Management</Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h4">Welcome, {localStorage.getItem('name')||''}</Typography>
        </Box>
      </Box>

      <Box sx={{ p: 3, backgroundColor: "#B6E1E4", minHeight: "100vh" }}>
        {/* Tabs */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ backgroundColor: '#fff', borderRadius: '16px', p: '6px', display: 'inline-flex', gap: '4px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
            {[
              { icon: <Send sx={{ fontSize: 18 }} />, label: 'Add Lead' },
              { icon: <Assessment sx={{ fontSize: 18 }} />, label: 'Call Reports' },
              ...(hasAgentManagementAccess ? [{ icon: <People sx={{ fontSize: 18 }} />, label: 'Manage Agents' }] : []),
            ].map((tab, idx) => (
              <Box
                key={idx}
                onClick={() => setActiveTab(idx)}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 0.75,
                  px: 2.5, py: 1,
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontWeight: 700,
                  fontSize: '0.9rem',
                  transition: 'all 0.2s',
                  userSelect: 'none',
                  backgroundColor: activeTab === idx ? '#1a1a2e' : 'transparent',
                  color: activeTab === idx ? '#B6E1E4' : '#6b7280',
                  '&:hover': activeTab !== idx ? { backgroundColor: '#f3f4f6', color: '#374151' } : {},
                }}
              >
                {tab.icon}
                {tab.label}
              </Box>
            ))}
          </Box>
        </Box>

        {/* Tab Content */}
        {activeTab === 0 && (
          <Box>
            {/* Summary Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Lead Summary (Today) */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", border: "2px solid #000" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                    textDecoration: "underline",
                  }}
                >
                  Lead Summary (Today)
                </Typography>
                <Box sx={{ textAlign: "left" }}>
                  {leadsDashboardData?.todaySummary && (
                    <>
                      {leadsDashboardData?.todaySummary?.totalLeads ? (
                        <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                          Total Leads :{" "}
                          {leadsDashboardData?.todaySummary?.totalLeads || 0}
                        </Typography>
                      ) : null}
                      {Object.entries(
                        leadsDashboardData?.todaySummary?.callStatusCounts
                      ).map((item) => {
                        return (
                          <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                            {item[0]} : {item[1]}
                          </Typography>
                        );
                      })}
                    </>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Hourly Leads (Today) */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", border: "2px solid #000" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                    textDecoration: "underline",
                  }}
                >
                  Hourly Leads (Today)
                </Typography>
                <Box sx={{ textAlign: "left" }}>
                  {leadsDashboardData?.hourlyLeadsToday.map((item) => {
                    return (
                      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                        {item?.hour} : {item?.count}
                      </Typography>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Lead Summary (Till Date) */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", border: "2px solid #000" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                    textDecoration: "underline",
                  }}
                >
                  Lead Summary (Till Date)
                </Typography>
                <Box sx={{ textAlign: "left" }}>
                  {leadsDashboardData?.tillDateSummary && (
                    <>
                      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                        Total Leads :{" "}
                        {leadsDashboardData?.tillDateSummary?.totalLeads || 0}
                      </Typography>
                      {Object.entries(
                        leadsDashboardData?.tillDateSummary?.callStatusCounts
                      ).map((item) => {
                        return (
                          <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                            {item[0]} : {item[1]}
                          </Typography>
                        );
                      })}
                    </>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Form Fields */}
        <Box>
          <Paper sx={{bgcolor: 'transparent', boxShadow: 'none', backgroundImage: 'none'}}>

        <Grid container spacing={3}>
          {/* Contact No - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="Contact No"
                value={formData.phoneNumber}
                onChange={(e) =>
                  handleInputChange("phoneNumber", e.target.value)
                }
                variant="outlined"
                type="number"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1, color: "#666" }} />,
                  style: {
                    MozAppearance: "textfield",
                  },
                }}
                inputProps={{
                  inputMode: "numeric",
                  maxLength: 10,
                }}
              />
            </Box>
          </Grid>

          {/* Seller Name - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                // label="Seller Name"
                placeholder="Seller Name"
                value={formData.sellerName}
                onChange={(e) =>
                  handleInputChange("sellerName", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                }}
                InputProps={{
                  startAdornment: <Person sx={{ mr: 1, color: "#666" }} />,
                }}
              />
            </Box>
          </Grid>

          {/* Product Category - Dropdown */}
          <Grid item xs={12} md={4}>
            <Box>
              <FormControl fullWidth>
                <InputLabel
                  id="dropdown-label"
                  style={{ backgroundColor: "white", color: "#000" }}
                >
                  Select Product Category
                </InputLabel>
                <Select
                  value={formData.productCategory}
                  onChange={(e) =>
                    handleInputChange("productCategory", e.target.value)
                  }
                  placeholder="Product Category"
                  sx={{
                    border: "2px solid #000",
                    backgroundColor: "white",
                  }}
                  startAdornment={<Category sx={{ mr: 1, color: "#666" }} />}
                >
                  {dropdownOptions.productCategories.map((category) => (
                    <MenuItem key={category} value={category}>
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Alternate No - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="Alternate No"
                value={formData.alternateNumber}
                type="text"
                onChange={(e) =>
                  handleInputChange("alternateNumber", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                inputProps={{
                  inputMode: "numeric",
                  maxLength: 10,
                }}
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1, color: "#666" }} />,
                  style: {
                    MozAppearance: "textfield",
                  },
                }}
              />
            </Box>
          </Grid>

          {/* City Name - Dropdown */}
          <Grid item xs={12} md={4}>
            <Box>
              <FormControl fullWidth>
                <Autocomplete
                  value={formData.city}
                  onChange={(event, newValue) =>
                    handleInputChange("city", newValue)
                  }
                  options={dropdownOptions.cities.map((city) => city.city)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select City"
                      placeholder="City Name"
                      style={{ borderRadius: 12 }}
                      sx={{
                        // backgroundColor: "white",
                        border: "2px solid #000",
                        // borderRadius:
                      }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <LocationCity sx={{ mr: 1, color: "#666" }} />
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Box>
          </Grid>

          {/* State Name - Auto Pick Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="State Name"
                value={formData.state}
                variant="outlined"
                disabled
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "#f0f0f0",
                  },
                }}
                InputProps={{
                  startAdornment: <LocationOn sx={{ mr: 1, color: "#666" }} />,
                }}
              />
            </Box>
          </Grid>

          {/* Call Status - Dropdown */}
          <Grid item xs={12} md={4}>
            <Box>
              <FormControl fullWidth>
                <InputLabel
                  id="dropdown-label"
                  style={{ backgroundColor: "white", color: "#000" }}
                >
                  Call Status
                </InputLabel>
                <Select
                  value={formData.callStatus}
                  labelId="dropdown-label"
                  onChange={(e) =>
                    handleInputChange("callStatus", e.target.value)
                  }
                  placeholder="Call Status"
                  sx={{
                    border: "2px solid #000",
                    backgroundColor: "white",
                  }}
                  startAdornment={<CallEnd sx={{ mr: 1, color: "#666" }} />}
                >
                  {dropdownOptions.callStatuses.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Follow Up Date & Time */}
          {formData.callStatus.toLowerCase().includes("follow") && (
            <Grid item xs={12} md={4}>
              <Box>
                <TextField
                  fullWidth
                  label="Follow Up Date & Time"
                  type="datetime-local"
                  value={formData.followUpDateTime}
                  onChange={(e) => handleInputChange("followUpDateTime", e.target.value)}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: new Date().toISOString().slice(0, 16) }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      border: "2px solid #000",
                      backgroundColor: "white",
                    },
                  }}
                />
              </Box>
            </Grid>
          )}

          {/* Call Remarks - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="Call Remarks"
                value={formData.callRemark}
                onChange={(e) =>
                  handleInputChange("callRemark", e.target.value)
                }
                variant="outlined"
                multiline
                rows={3}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Comment
                      sx={{
                        mr: 1,
                        color: "#666",
                        alignSelf: "flex-start",
                        mt: 1,
                      }}
                    />
                  ),
                }}
              />
            </Box>
          </Grid>

          {canUseWhatsappFeatures && (
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.25 }}>
                  <Box sx={{
                    width: 8, height: 8, borderRadius: '50%',
                    backgroundColor: myWaStatus === 'ready' ? '#25d366' : '#9ca3af',
                  }} />
                  <Typography variant="caption" sx={{ color: myWaStatus === 'ready' ? '#25d366' : '#9ca3af', fontWeight: 700 }}>
                    WhatsApp {myWaStatus === 'ready' ? 'Connected ✓' : 'Not Connected'}
                  </Typography>
                </Box>

                <FormControl fullWidth variant="outlined" sx={{ '& .MuiOutlinedInput-root': { border: '2px solid #000', backgroundColor: 'white' } }}>
                  <InputLabel>Send Catalog via WhatsApp</InputLabel>
                  <Select
                    value={selectedCatalogId}
                    onChange={(e) => setSelectedCatalogId(e.target.value)}
                    label="Send Catalog via WhatsApp"
                    startAdornment={<WhatsApp sx={{ mr: 1, color: '#25d366', fontSize: 20 }} />}
                  >
                    <MenuItem value=""><em>— Select a catalog —</em></MenuItem>
                    {catalogs.map(c => (
                      <MenuItem key={c.id} value={c.id}>
                        <Box>
                          <Typography sx={{ fontWeight: 700, fontSize: '0.88rem' }}>{c.name}</Typography>
                          <Typography variant="caption" sx={{ color: '#888' }}>{c.description}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {lastCatalogSent && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, px: 1, py: 0.75, backgroundColor: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
                    <WhatsApp sx={{ fontSize: 14, color: '#25d366', mt: '2px', flexShrink: 0 }} />
                    <Typography variant="caption" sx={{ color: '#166534', lineHeight: 1.4 }}>
                      <strong>Last sent:</strong> {lastCatalogSent.catalogName || lastCatalogSent.catalogUrl}<br />
                      {new Date(lastCatalogSent.sentAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </Typography>
                  </Box>
                )}

                <Button
                  variant="contained"
                  onClick={handleSendCatalog}
                  disabled={!selectedCatalogId || catalogSending || !formData.phoneNumber || formData.phoneNumber.length !== 10}
                  startIcon={catalogSending ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : <WhatsApp />}
                  sx={{
                    backgroundColor: '#25d366',
                    color: '#fff',
                    borderRadius: '12px',
                    fontWeight: 700,
                    textTransform: 'none',
                    fontSize: '0.9rem',
                    '&:hover': { backgroundColor: '#128C7E' },
                    '&:disabled': { backgroundColor: '#d1d5db', color: '#fff' },
                  }}
                >
                  {catalogSending ? 'Sending…' : 'Send Catalog'}
                </Button>
              </Box>
            </Grid>
          )}

          {/* Submit Button */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Button
                variant="contained"
                onClick={() => submitData(false)}
                sx={{
                  backgroundColor: "#000",
                  color: "white",
                  borderRadius: "25px",
                  px: 4,
                  py: 2,
                  fontSize: "16px",
                  fontWeight: "bold",
                  height: "48px",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
                startIcon={<Send />}
                disabled={
                  !formData.city ||
                  !formData.productCategory ||
                  !formData.callStatus ||
                  !formData.sellerName ||
                  !formData.callRemark ||
                  !formData.phoneNumber ||
                  loading ||
                  formData.phoneNumber.length != 10
                }
              >
                Submit
              </Button>

              {canUseWhatsappFeatures && (
                <Button
                  variant="outlined"
                  onClick={handleConnectMyWhatsapp}
                  startIcon={<WhatsApp sx={{ fontSize: 18 }} />}
                  sx={{
                    backgroundColor: 'white',
                    borderColor: '#25d366',
                    color: '#25d366',
                    borderRadius: '25px',
                    px: 3,
                    py: 1.5,
                    fontSize: '14px',
                    fontWeight: 'bold',
                    height: '48px',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: '#e8f5e9', borderColor: '#25d366' },
                  }}
                >
                  {myWaStatus === 'ready' ? 'WhatsApp ✓' : 'Connect WhatsApp'}
                </Button>
              )}

            </Box>
          </Grid>
        </Grid>

          </Paper>
        </Box>
          </Box>
        )}

        {/* Call Reports Tab */}
        {activeTab === 1 && (
          <Box>
            {/* Page Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ width: 44, height: 44, borderRadius: '12px', background: 'linear-gradient(135deg,#1a1a2e,#16213e)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Assessment sx={{ color: '#B6E1E4', fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a2e', lineHeight: 1.1 }}>
                    Call Reports
                  </Typography>
                  {callReportsMeta && (
                    <Typography variant="caption" sx={{ color: '#555', fontWeight: 500 }}>
                      {callReportsMeta.totalDocuments.toLocaleString()} total records
                    </Typography>
                  )}
                </Box>
              </Box>
              <Tooltip title="Refresh">
                <IconButton
                  onClick={() => getCallReports(callReportPage, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter)}
                  disabled={callReportsLoading}
                  sx={{
                    backgroundColor: '#fff',
                    border: '2px solid #1a1a2e',
                    borderRadius: '12px',
                    width: 44, height: 44,
                    '&:hover': { backgroundColor: '#f0f0f0' },
                    transition: 'transform 0.2s',
                    ...(callReportsLoading && { animation: 'spin 1s linear infinite' }),
                  }}
                >
                  <Refresh sx={{ color: '#1a1a2e', fontSize: 20 }} />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Filters Card */}
            <Card sx={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', mb: 3, overflow: 'visible' }}>
              <Box sx={{ p: 2.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <FilterList sx={{ color: '#555', fontSize: 18 }} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a2e' }}>Filters</Typography>
                  {(callReportStatusFilter || callReportAgentFilter || callReportPhoneFilter) && (
                    <Chip
                      label="Active"
                      size="small"
                      sx={{ backgroundColor: '#e3f2fd', color: '#1565c0', fontWeight: 700, fontSize: '0.7rem', height: 20 }}
                    />
                  )}
                </Box>

                {/* Status quick-select pills */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                  {['', ...dropdownOptions.callStatuses].map((status) => {
                    const isActive = callReportStatusFilter === status;
                    const style = status ? getStatusStyle(status) : { bg: '#1a1a2e', color: '#fff', border: '#1a1a2e' };
                    return (
                      <Chip
                        key={status || 'all'}
                        label={status || 'All'}
                        clickable
                        onClick={() => {
                          setCallReportStatusFilter(status);
                          setCallReportPage(1);
                          getCallReports(1, status, callReportAgentFilter, callReportPhoneFilter);
                        }}
                        sx={{
                          fontWeight: 700,
                          fontSize: '0.75rem',
                          height: 30,
                          backgroundColor: isActive ? style.bg : '#f3f4f6',
                          color: isActive ? style.color : '#374151',
                          border: `1.5px solid ${isActive ? style.border : 'transparent'}`,
                          transition: 'all 0.18s',
                          '&:hover': { backgroundColor: style.bg, color: style.color, border: `1.5px solid ${style.border}` },
                        }}
                      />
                    );
                  })}
                </Box>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  {hasAgentManagementAccess && (
                    <Autocomplete
                      size="small"
                      options={callReportAgents}
                      value={callReportAgents.find((agent) => agent._id === callReportAgentFilter) || null}
                      onChange={(_, value) => {
                        const nextAgentId = value?._id || '';
                        setCallReportAgentFilter(nextAgentId);
                        setCallReportPage(1);
                        getCallReports(1, callReportStatusFilter, nextAgentId, callReportPhoneFilter);
                      }}
                      getOptionLabel={(option) => option?.name ? `${option.name} (${option.userName || option._id})` : ''}
                      isOptionEqualToValue={(option, value) => option?._id === value?._id}
                      sx={{
                        minWidth: 300,
                        '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#f8fafc' },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Agent"
                          placeholder="Choose agent"
                        />
                      )}
                    />
                  )}
                  <TextField
                    size="small"
                    label="Search by Phone Number"
                    placeholder="Enter phone number"
                    value={callReportPhoneFilter}
                    onChange={(e) => setCallReportPhoneFilter(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setCallReportPage(1);
                        getCallReports(1, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter);
                      }
                    }}
                    sx={{
                      minWidth: 240,
                      '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#f8fafc' },
                    }}
                    InputProps={{ startAdornment: <Phone sx={{ mr: 1, color: '#999', fontSize: 18 }} /> }}
                  />
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => { setCallReportPage(1); getCallReports(1, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter); }}
                    sx={{ borderRadius: '10px', backgroundColor: '#1a1a2e', '&:hover': { backgroundColor: '#16213e' }, textTransform: 'none', fontWeight: 700, px: 2.5 }}
                  >
                    Search
                  </Button>
                  {(callReportAgentFilter || callReportPhoneFilter) && (
                    <Button
                      size="small"
                      onClick={() => {
                        setCallReportAgentFilter('');
                        setCallReportPhoneFilter('');
                        setCallReportPage(1);
                        getCallReports(1, callReportStatusFilter, '', '');
                      }}
                      sx={{ borderRadius: '10px', color: '#c62828', textTransform: 'none', fontWeight: 600 }}
                    >
                      Clear
                    </Button>
                  )}
                </Box>
              </Box>
            </Card>

            {/* Table Card */}
            <Card sx={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
              {/* Table top bar */}
              <Box sx={{ px: 3, py: 2, background: 'linear-gradient(135deg,#1a1a2e,#16213e)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#fff' }}>
                  Results
                </Typography>
                {callReportsMeta && !callReportsLoading && (
                  <Chip
                    label={`${callReports.length} of ${callReportsMeta.totalDocuments} records`}
                    size="small"
                    sx={{ backgroundColor: 'rgba(182,225,228,0.2)', color: '#B6E1E4', fontWeight: 600, fontSize: '0.7rem' }}
                  />
                )}
              </Box>

              <TableContainer>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                      {['', '#', 'Name', 'Phone Number', ...(hasAgentManagementAccess ? ['Agent'] : []), 'Status', 'Location', 'Duration', 'Follow Up', 'Remark', 'Date & Time'].map((col) => (
                        <TableCell
                          key={col}
                          sx={{
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            color: '#374151',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            borderBottom: '2px solid #e5e7eb',
                            py: 1.5,
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {col}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {callReportsLoading ? (
                      [...Array(8)].map((_, i) => (
                        <TableRow key={i} sx={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                          {[...Array(hasAgentManagementAccess ? 11 : 10)].map((__, j) => (
                            <TableCell key={j} sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5 }}>
                              <Skeleton variant="text" width={j === 0 ? 24 : j === 8 ? 110 : '80%'} height={20} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    ) : callReports.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={hasAgentManagementAccess ? 11 : 10} sx={{ py: 8, textAlign: 'center', border: 'none' }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ width: 56, height: 56, borderRadius: '50%', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <SearchOff sx={{ fontSize: 28, color: '#9ca3af' }} />
                            </Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#374151' }}>No reports found</Typography>
                            <Typography variant="body2" sx={{ color: '#9ca3af' }}>
                              {callReportStatusFilter ? `No calls with status "${callReportStatusFilter}"` : 'No call reports available yet'}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : (
                      callReports.map((report, index) => {
                        const statusStyle = getStatusStyle(report.callStatus);
                        const isEven = index % 2 === 0;
                        const reportPhone = String(report.phoneNumber || '').replace(/\D/g, '');
                        const isExpanded = !!expandedCallRows[reportPhone];
                        const historyItems = callHistoryByPhone[reportPhone] || [];
                        const historyLoading = !!callHistoryLoadingByPhone[reportPhone];
                        return (
                          <Fragment key={report._id}>
                            <TableRow
                              hover
                              sx={{
                                backgroundColor: isEven ? '#fff' : '#fafafa',
                                transition: 'background-color 0.15s',
                                '&:hover': { backgroundColor: '#f0f9fa !important' },
                              }}
                            >
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1, width: 48 }}>
                                <IconButton
                                  size="small"
                                  onClick={() => toggleCallReportRow(report.phoneNumber)}
                                  sx={{ border: '1px solid #dbe2ea', borderRadius: '8px' }}
                                >
                                  {isExpanded ? <KeyboardArrowUp sx={{ fontSize: 18 }} /> : <KeyboardArrowDown sx={{ fontSize: 18 }} />}
                                </IconButton>
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5, color: '#9ca3af', fontSize: '0.8rem', fontWeight: 600, width: 40 }}>
                                {((callReportPage - 1) * 20) + index + 1}
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5 }}>
                                <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#1a1a2e' }}>
                                  {report.sellerName || '—'}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Box sx={{ width: 28, height: 28, borderRadius: '8px', backgroundColor: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <PhoneInTalk sx={{ fontSize: 14, color: '#2e7d32' }} />
                                  </Box>
                                  <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', fontFamily: 'monospace', letterSpacing: '0.05em', color: '#1a1a2e' }}>
                                    {report.phoneNumber}
                                  </Typography>
                                </Box>
                              </TableCell>
                              {hasAgentManagementAccess && (
                                <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Avatar
                                      sx={{ width: 28, height: 28, fontSize: '0.7rem', fontWeight: 700, backgroundColor: '#1a1a2e', color: '#B6E1E4' }}
                                    >
                                      {(report.agentName || '?').charAt(0).toUpperCase()}
                                    </Avatar>
                                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#374151' }}>
                                      {report.agentName || '—'}
                                    </Typography>
                                  </Box>
                                </TableCell>
                              )}
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5 }}>
                                <Chip
                                  label={report.callStatus}
                                  size="small"
                                  sx={{
                                    backgroundColor: statusStyle.bg,
                                    color: statusStyle.color,
                                    border: `1.5px solid ${statusStyle.border}`,
                                    fontWeight: 700,
                                    fontSize: '0.72rem',
                                    height: 24,
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                                  <LocationOn sx={{ fontSize: 14, color: '#9ca3af', mt: '1px', flexShrink: 0 }} />
                                  <Box>
                                    <Typography sx={{ fontSize: '0.83rem', fontWeight: 600, color: '#374151', lineHeight: 1.2 }}>
                                      {report.city || '—'}
                                    </Typography>
                                    <Typography sx={{ fontSize: '0.72rem', color: '#9ca3af' }}>{report.state}</Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5, whiteSpace: 'nowrap' }}>
                                {report.duration ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    <Timer sx={{ fontSize: 14, color: '#6366f1' }} />
                                    <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, color: '#374151' }}>
                                      {formatDuration(report.duration)}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Typography sx={{ fontSize: '0.78rem', color: '#d1d5db', fontStyle: 'italic' }}>—</Typography>
                                )}
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5, whiteSpace: 'nowrap' }}>
                                {report.followUpTime ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    <AccessTime sx={{ fontSize: 14, color: '#e65100' }} />
                                    <Box>
                                      <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', lineHeight: 1.2 }}>
                                        {new Date(report.followUpTime).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                                      </Typography>
                                      <Typography sx={{ fontSize: '0.7rem', color: '#e65100' }}>
                                        {new Date(report.followUpTime).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
                                      </Typography>
                                    </Box>
                                  </Box>
                                ) : (
                                  <Typography sx={{ fontSize: '0.78rem', color: '#d1d5db', fontStyle: 'italic' }}>—</Typography>
                                )}
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5, maxWidth: 200 }}>
                                <Tooltip title={report.callRemark || ''} placement="top" arrow>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontSize: '0.82rem',
                                      color: '#4b5563',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      maxWidth: 180,
                                      cursor: report.callRemark?.length > 30 ? 'help' : 'default',
                                    }}
                                  >
                                    {report.callRemark || <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>No remark</span>}
                                  </Typography>
                                </Tooltip>
                              </TableCell>
                              <TableCell sx={{ borderBottom: '1px solid #f0f0f0', py: 1.5, whiteSpace: 'nowrap' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                  <CalendarToday sx={{ fontSize: 12, color: '#9ca3af' }} />
                                  <Box>
                                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', lineHeight: 1.2 }}>
                                      {new Date(report.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                                    </Typography>
                                    <Typography sx={{ fontSize: '0.7rem', color: '#9ca3af' }}>
                                      {new Date(report.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                colSpan={hasAgentManagementAccess ? 11 : 10}
                                sx={{ py: 0, borderBottom: isExpanded ? '1px solid #f0f0f0' : 'none', backgroundColor: '#fbfdff' }}
                              >
                                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                  <Box sx={{ px: 3, py: 2 }}>
                                    <Typography sx={{ fontWeight: 700, color: '#1a1a2e', mb: 1.5 }}>
                                      Catalog History
                                    </Typography>
                                    {historyLoading ? (
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <CircularProgress size={18} />
                                        <Typography sx={{ fontSize: '0.85rem', color: '#6b7280' }}>
                                          Loading history...
                                        </Typography>
                                      </Box>
                                    ) : historyItems.length === 0 ? (
                                      <Typography sx={{ fontSize: '0.85rem', color: '#9ca3af' }}>
                                        No catalog history found for this phone number.
                                      </Typography>
                                    ) : (
                                      <Box sx={{ display: 'grid', gap: 1.25 }}>
                                        {historyItems.map((item, historyIndex) => {
                                          const assetUrl = getCatalogAssetUrl(item);
                                          const assetType = getCatalogAssetType(assetUrl);
                                          return (
                                            <Box
                                              key={item._id || `${reportPhone}-${historyIndex}`}
                                              sx={{
                                                p: 2,
                                                border: '1px solid #dbe7f0',
                                                borderRadius: '16px',
                                                background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
                                                boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)',
                                              }}
                                            >
                                              <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: 1.5, flexWrap: 'wrap' }}>
                                                <Box>
                                                  <Typography sx={{ fontSize: '0.92rem', fontWeight: 800, color: '#1f2937' }}>
                                                    {item.catalogName || item.name || item.templateName || 'Catalog Entry'}
                                                  </Typography>
                                                  <Typography sx={{ fontSize: '0.8rem', color: '#6b7280', mt: 0.5 }}>
                                                    Sent on {new Date(item.sentAt || item.createdAt || item.updatedAt).toLocaleString('en-IN')}
                                                  </Typography>
                                                </Box>
                                                {assetUrl && (
                                                  <Button
                                                    component="a"
                                                    href={assetUrl}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    size="small"
                                                    endIcon={<OpenInNew sx={{ fontSize: 16 }} />}
                                                    sx={{
                                                      textTransform: 'none',
                                                      borderRadius: '999px',
                                                      px: 1.75,
                                                      py: 0.5,
                                                      backgroundColor: '#e8f1ff',
                                                      color: '#174ea6',
                                                      fontWeight: 700,
                                                      '&:hover': { backgroundColor: '#d7e7ff' },
                                                    }}
                                                  >
                                                    Open Preview
                                                  </Button>
                                                )}
                                              </Box>

                                              {(item.catalogId || item.phoneNumber || item.agentName) && (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: assetUrl ? 1.5 : 0 }}>
                                                  {item.catalogId && <Chip size="small" label={`Catalog ID: ${item.catalogId}`} sx={{ backgroundColor: '#eef2ff', color: '#3730a3', fontWeight: 700 }} />}
                                                  {item.phoneNumber && <Chip size="small" label={`Phone: ${item.phoneNumber}`} sx={{ backgroundColor: '#ecfeff', color: '#155e75', fontWeight: 700 }} />}
                                                  {item.agentName && <Chip size="small" label={`Agent: ${item.agentName}`} sx={{ backgroundColor: '#f0fdf4', color: '#166534', fontWeight: 700 }} />}
                                                </Box>
                                              )}

                                              {assetUrl && (
                                                <Box
                                                  sx={{
                                                    mt: 1,
                                                    overflow: 'hidden',
                                                    borderRadius: '14px',
                                                    border: '1px solid #e5e7eb',
                                                    backgroundColor: '#fff',
                                                  }}
                                                >
                                                  {assetType === 'image' ? (
                                                    <Box sx={{ position: 'relative', background: 'linear-gradient(135deg, #eff6ff, #f8fafc)', p: 1 }}>
                                                      <img
                                                        src={assetUrl}
                                                        alt={item.catalogName || item.name || 'Catalog preview'}
                                                        style={{ display: 'block', width: '100%', maxHeight: '260px', objectFit: 'contain', borderRadius: '10px' }}
                                                      />
                                                    </Box>
                                                  ) : assetType === 'pdf' ? (
                                                    <Box sx={{ p: 2 }}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                                        <PictureAsPdf sx={{ color: '#c62828', fontSize: 24 }} />
                                                        <Typography sx={{ fontWeight: 700, color: '#1f2937' }}>
                                                          PDF Preview
                                                        </Typography>
                                                      </Box>
                                                      <Box
                                                        component="iframe"
                                                        src={assetUrl}
                                                        title={`catalog-preview-${historyIndex}`}
                                                        sx={{ width: '100%', height: 280, border: 'none', borderRadius: '10px', backgroundColor: '#f8fafc' }}
                                                      />
                                                    </Box>
                                                  ) : (
                                                    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                      <ImageIcon sx={{ color: '#64748b', fontSize: 22 }} />
                                                      <Typography sx={{ fontSize: '0.84rem', color: '#475569' }}>
                                                        Preview link available. Open it in a new tab.
                                                      </Typography>
                                                    </Box>
                                                  )}
                                                </Box>
                                              )}
                                            </Box>
                                          );
                                        })}
                                      </Box>
                                    )}
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </Fragment>
                        );
                      })
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination footer */}
              {callReportsMeta && callReportsMeta.totalPages > 1 && (
                <Box sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0', backgroundColor: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" sx={{ color: '#6b7280', fontSize: '0.82rem' }}>
                    Page <strong>{callReportsMeta.currentPage}</strong> of <strong>{callReportsMeta.totalPages}</strong>
                    &nbsp;·&nbsp;{callReportsMeta.totalDocuments.toLocaleString()} total
                  </Typography>
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <IconButton
                      size="small"
                      disabled={callReportPage <= 1 || callReportsLoading}
                      onClick={() => { const p = callReportPage - 1; setCallReportPage(p); getCallReports(p, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter); }}
                      sx={{ border: '1.5px solid #e5e7eb', borderRadius: '8px', width: 32, height: 32, '&:disabled': { opacity: 0.4 } }}
                    >
                      <ChevronLeft sx={{ fontSize: 18 }} />
                    </IconButton>

                    {/* Page number buttons */}
                    {Array.from({ length: callReportsMeta.totalPages }, (_, i) => i + 1)
                      .filter(p => p === 1 || p === callReportsMeta.totalPages || Math.abs(p - callReportPage) <= 1)
                      .reduce((acc, p, idx, arr) => {
                        if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
                        acc.push(p);
                        return acc;
                      }, [])
                      .map((p, i) =>
                        p === '...' ? (
                          <Typography key={`ellipsis-${i}`} sx={{ px: 0.5, color: '#9ca3af', fontSize: '0.85rem' }}>…</Typography>
                        ) : (
                          <IconButton
                            key={p}
                            size="small"
                            onClick={() => { setCallReportPage(p); getCallReports(p, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter); }}
                            disabled={callReportsLoading}
                            sx={{
                              border: '1.5px solid',
                              borderColor: callReportPage === p ? '#1a1a2e' : '#e5e7eb',
                              borderRadius: '8px',
                              width: 32, height: 32,
                              backgroundColor: callReportPage === p ? '#1a1a2e' : 'transparent',
                              color: callReportPage === p ? '#fff' : '#374151',
                              fontWeight: 700,
                              fontSize: '0.8rem',
                              '&:hover': { backgroundColor: callReportPage === p ? '#16213e' : '#f3f4f6' },
                            }}
                          >
                            {p}
                          </IconButton>
                        )
                      )}

                    <IconButton
                      size="small"
                      disabled={callReportPage >= callReportsMeta.totalPages || callReportsLoading}
                      onClick={() => { const p = callReportPage + 1; setCallReportPage(p); getCallReports(p, callReportStatusFilter, callReportAgentFilter, callReportPhoneFilter); }}
                      sx={{ border: '1.5px solid #e5e7eb', borderRadius: '8px', width: 32, height: 32, '&:disabled': { opacity: 0.4 } }}
                    >
                      <ChevronRight sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Stack>
                </Box>
              )}
            </Card>
          </Box>
        )}

        {/* Agent Management Tab */}
        {activeTab === 2 && hasAgentManagementAccess && (
          <Box>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
              Agent List & State Management
            </Typography>
            
            {/* Search Filter */}
            <Card sx={{ border: "2px solid #000", mb: 3, p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Search Agents
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={8}>
                  <TextField
                    fullWidth
                    label="Search by Name or Phone Number"
                    placeholder="Enter agent name or phone number..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        border: "2px solid #000",
                        backgroundColor: "white",
                      },
                    }}
                    InputProps={{
                      startAdornment: <Person sx={{ mr: 1, color: "#666" }} />,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      Showing {filteredAgents.length} of {agentsList.length} agents
                    </Typography>
                    {searchQuery && (
                      <Button
                        variant="outlined"
                        onClick={() => setSearchQuery('')}
                        sx={{
                          border: '1px solid #000',
                          color: '#000',
                          '&:hover': {
                            backgroundColor: '#f0f0f0',
                            border: '1px solid #000',
                          }
                        }}
                      >
                        Clear
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Card>
            
            <Card sx={{ border: "2px solid #000" }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 'bold', border: '1px solid #ddd' }}>
                        Agent Name
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', border: '1px solid #ddd' }}>
                        Username
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', border: '1px solid #ddd' }}>
                        Assigned States
                      </TableCell>
                      {canUseWhatsappFeatures && (
                        <TableCell sx={{ fontWeight: 'bold', border: '1px solid #ddd', textAlign: 'center' }}>
                          WhatsApp
                        </TableCell>
                      )}
                      <TableCell sx={{ fontWeight: 'bold', border: '1px solid #ddd', textAlign: 'center' }}>
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredAgents.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={canUseWhatsappFeatures ? 5 : 4} sx={{ textAlign: 'center', py: 4, border: '1px solid #ddd' }}>
                          <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
                            No agents found
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#999' }}>
                            {searchQuery
                              ? 'Try adjusting your search criteria'
                              : 'No agents available'
                            }
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredAgents
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((agent) => (
                          <TableRow key={agent._id} hover>
                            <TableCell sx={{ border: '1px solid #ddd', fontWeight: 'bold' }}>
                              {agent.name}
                            </TableCell>
                            <TableCell sx={{ border: '1px solid #ddd' }}>
                              {agent.userName}
                            </TableCell>
                            <TableCell sx={{ border: '1px solid #ddd' }}>
                              <Box display="flex" flexWrap="wrap" gap={0.5}>
                                {agent.assignedState && agent.assignedState.length > 0 ? (
                                  agent.assignedState.map((state, index) => (
                                    <Chip
                                      key={index}
                                      label={state}
                                      size="small"
                                      sx={{
                                        backgroundColor: '#B6E1E4',
                                        border: '1px solid #000',
                                        fontWeight: 'bold',
                                        fontSize: '0.75rem'
                                      }}
                                    />
                                  ))
                                ) : (
                                  <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
                                    No states assigned
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            {canUseWhatsappFeatures && (
                              <TableCell sx={{ border: '1px solid #ddd', textAlign: 'center' }}>
                                {(() => {
                                  const waStatus = agentWaStatuses[agent._id];
                                  const isReady = waStatus === 'ready';
                                  return (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                      <Chip
                                        icon={<WhatsApp sx={{ fontSize: 14 }} />}
                                        label={isReady ? 'Connected' : waStatus === 'qr_pending' ? 'Scan QR' : waStatus === 'authenticated' ? 'Authenticating' : 'Not Connected'}
                                        size="small"
                                        sx={{
                                          backgroundColor: isReady ? '#e8f5e9' : waStatus === 'qr_pending' ? '#fff3e0' : '#f5f5f5',
                                          color: isReady ? '#2e7d32' : waStatus === 'qr_pending' ? '#e65100' : '#757575',
                                          border: `1px solid ${isReady ? '#a5d6a7' : waStatus === 'qr_pending' ? '#ffcc80' : '#e0e0e0'}`,
                                          fontWeight: 700,
                                          fontSize: '0.7rem',
                                        }}
                                      />
                                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          startIcon={<WhatsApp sx={{ fontSize: 14 }} />}
                                          onClick={() => handleOpenWhatsappDialog(agent)}
                                          sx={{
                                            fontSize: '0.7rem', px: 1, py: 0.25,
                                            borderColor: '#25d366', color: '#25d366',
                                            '&:hover': { backgroundColor: '#e8f5e9', borderColor: '#25d366' },
                                            textTransform: 'none', fontWeight: 700,
                                          }}
                                        >
                                          {isReady ? 'Manage' : 'Connect'}
                                        </Button>
                                        {isReady && (
                                          <IconButton
                                            size="small"
                                            title="Disconnect WhatsApp"
                                            onClick={() => handleDisconnectWhatsapp(agent._id)}
                                            sx={{ color: '#c62828', p: 0.25 }}
                                          >
                                            <LinkOff sx={{ fontSize: 16 }} />
                                          </IconButton>
                                        )}
                                      </Box>
                                    </Box>
                                  );
                                })()}
                              </TableCell>
                            )}

                            <TableCell sx={{ border: '1px solid #ddd', textAlign: 'center' }}>
                              <IconButton
                                onClick={() => handleEditAgent(agent)}
                                sx={{
                                  color: '#000',
                                  '&:hover': { backgroundColor: '#f0f0f0' }
                                }}
                                title="Edit States"
                              >
                                <Edit />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={filteredAgents.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  borderTop: '1px solid #ddd',
                  '& .MuiTablePagination-toolbar': {
                    backgroundColor: '#f9f9f9'
                  }
                }}
              />
            </Card>
          </Box>
        )}

        {/* Unauthorized Access Message */}
        {activeTab === 2 && !hasAgentManagementAccess && (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h5" sx={{ mb: 2, color: '#666' }}>
              Access Denied
            </Typography>
            <Typography variant="body1" sx={{ color: '#999' }}>
              You don't have permission to access agent management features.
            </Typography>
          </Box>
        )}

        {/* ── WhatsApp QR Dialog ─────────────────────────────────────────── */}
        <Dialog
          open={whatsappDialogOpen}
          onClose={handleCloseWhatsappDialog}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle sx={{ background: 'linear-gradient(135deg,#25d366,#128C7E)', color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }}>
            <WhatsApp />
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              WhatsApp — {whatsappAgent?.name}
            </Typography>
          </DialogTitle>

          <DialogContent sx={{ textAlign: 'center', py: 3 }}>
            {whatsappConnecting ? (
              <Box sx={{ py: 4 }}>
                <CircularProgress sx={{ color: '#25d366' }} />
                <Typography sx={{ mt: 2, color: '#666' }}>Initialising session…</Typography>
              </Box>
            ) : whatsappStatus === 'ready' ? (
              <Box sx={{ py: 3 }}>
                <WhatsApp sx={{ fontSize: 72, color: '#25d366' }} />
                <Typography variant="h6" sx={{ fontWeight: 700, color: '#2e7d32', mt: 1 }}>
                  Connected!
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', mt: 0.5 }}>
                  WhatsApp is active for {whatsappAgent?.name}. They can now send catalogs to customers.
                </Typography>
              </Box>
            ) : whatsappStatus === 'auth_failure' ? (
              <Box sx={{ py: 3 }}>
                <Typography variant="h6" sx={{ color: '#c62828', fontWeight: 700 }}>Auth Failed</Typography>
                <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                  Authentication failed. Please try connecting again.
                </Typography>
                <Button
                  variant="contained"
                  sx={{ mt: 2, backgroundColor: '#25d366', '&:hover': { backgroundColor: '#128C7E' } }}
                  onClick={() => handleOpenWhatsappDialog(whatsappAgent)}
                >
                  Retry
                </Button>
              </Box>
            ) : whatsappQR ? (
              <Box>
                <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
                  Open WhatsApp on your phone → Linked Devices → Link a Device, then scan this QR code.
                </Typography>
                <Box sx={{ border: '4px solid #25d366', borderRadius: '12px', display: 'inline-block', p: 1 }}>
                  <img src={whatsappQR} alt="WhatsApp QR Code" style={{ width: 240, height: 240, display: 'block' }} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mt: 2 }}>
                  <CircularProgress size={14} sx={{ color: '#25d366' }} />
                  <Typography variant="caption" sx={{ color: '#888' }}>Waiting for scan…</Typography>
                </Box>
              </Box>
            ) : ['disconnected', 'authenticated', 'initializing'].includes(whatsappStatus) ? (
              <Box sx={{ py: 4 }}>
                <CircularProgress sx={{ color: '#25d366' }} />
                <Typography sx={{ mt: 2, color: '#666' }}>Connecting to WhatsApp…</Typography>
                <Typography variant="caption" sx={{ color: '#aaa', mt: 0.5, display: 'block' }}>This may take a few seconds</Typography>
              </Box>
            ) : (
              <Box sx={{ py: 4 }}>
                <CircularProgress sx={{ color: '#25d366' }} />
                <Typography sx={{ mt: 2, color: '#666' }}>Generating QR code…</Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
            {whatsappStatus === 'ready' && (
              <Button
                variant="outlined"
                startIcon={<LinkOff />}
                onClick={() => { handleDisconnectWhatsapp(whatsappAgent._id); handleCloseWhatsappDialog(); }}
                sx={{ borderColor: '#c62828', color: '#c62828', textTransform: 'none', fontWeight: 700 }}
              >
                Disconnect
              </Button>
            )}
            <Box sx={{ ml: 'auto' }}>
              <Button onClick={handleCloseWhatsappDialog} sx={{ color: '#666', textTransform: 'none', fontWeight: 600 }}>
                Close
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
        {/* ── End WhatsApp QR Dialog ──────────────────────────────────────── */}

        {/* Edit Agent States Dialog */}
        <Dialog 
          open={editDialogOpen} 
          onClose={() => setEditDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {selectedAgent?.assignedState && selectedAgent.assignedState.length > 0 
                ? `Edit States for ${selectedAgent?.name}` 
                : `Assign States to ${selectedAgent?.name}`}
            </Typography>
          </DialogTitle>
          
          <DialogContent>
            <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
              {selectedAgent?.assignedState && selectedAgent.assignedState.length > 0 
                ? "Select states to assign to this agent:" 
                : "This agent has no assigned states yet. Select states to assign:"}
            </Typography>
            
            {/* Action Buttons */}
            <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Button
                variant="outlined"
                onClick={handleToggleAllStates}
                sx={{
                  border: '1px solid #000',
                  color: '#000',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #000',
                  }
                }}
              >
                {selectedStates.length === availableStates.length ? 'Deselect All' : 'Select All'}
              </Button>
              <Button
                variant="outlined"
                onClick={handleSelectAllStates}
                disabled={selectedStates.length === availableStates.length}
                sx={{
                  border: '1px solid #000',
                  color: '#000',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #000',
                  },
                  '&:disabled': {
                    border: '1px solid #ccc',
                    color: '#ccc'
                  }
                }}
              >
                Select All
              </Button>
              <Button
                variant="outlined"
                onClick={handleDeselectAllStates}
                disabled={selectedStates.length === 0}
                sx={{
                  border: '1px solid #000',
                  color: '#000',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #000',
                  },
                  '&:disabled': {
                    border: '1px solid #ccc',
                    color: '#ccc'
                  }
                }}
              >
                Deselect All
              </Button>
            </Box>
            
            {/* Show currently selected states */}
            {selectedStates.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                  Currently Selected ({selectedStates.length} of {availableStates.length}):
                </Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {selectedStates.map((state, index) => (
                    <Chip
                      key={index}
                      label={state}
                      size="small"
                      onDelete={() => handleStateToggle(state)}
                      sx={{
                        backgroundColor: '#B6E1E4',
                        border: '1px solid #000',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#a0d4d7'
                        }
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
            
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
              Available States ({availableStates.length}):
            </Typography>
            
            <List sx={{ maxHeight: 300, overflow: 'auto', border: '1px solid #ddd', borderRadius: 1 }}>
              {availableStates.map((state) => (
                <ListItem 
                  key={state} 
                  dense
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: '#fafafa'
                    }
                  }}
                  onClick={() => handleStateToggle(state)}
                >
                  <ListItemText 
                    primary={state}
                    sx={{
                      '& .MuiListItemText-primary': {
                        fontWeight: selectedStates.includes(state) ? 'bold' : 'normal',
                        color: selectedStates.includes(state) ? '#000' : '#666'
                      }
                    }}
                  />
                  <ListItemSecondaryAction>
                    <Checkbox
                      checked={selectedStates.includes(state)}
                      onChange={() => handleStateToggle(state)}
                      sx={{ 
                        color: '#000',
                        '&.Mui-checked': {
                          color: '#000'
                        }
                      }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </DialogContent>
          
          <DialogActions>
            <Button 
              onClick={() => setEditDialogOpen(false)}
              sx={{ color: '#666' }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSaveAgentStates}
              variant="contained"
              sx={{
                backgroundColor: '#000',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#333',
                }
              }}
            >
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};

export default AddLeadsForAgent;
